import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { Modal } from '@/components';
import { useHistory } from '@/modules/core/hooks';

import { useGetRoleByIdQuery } from '../queries';
import { IRoleSetup } from '../role.types';
import RoleSetupForm from '../RoleSetup/RoleSetupForm';
import { CopyPermissionsSection } from '../RoleSetup/RoleSetupForm/PermissionsSection';
import { useRoleSetupStore } from '../RoleSetup/stores';

interface Props {
  id: string;
  onChangeId: (value: string) => void;
}
const RoleCopyModal: React.FC<Props> = ({ id, onChangeId }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (id) {
      setVisible(true);
    }
  }, [id]);
  const { data, isLoading } = useGetRoleByIdQuery({ id });
  
  const handleSetVisible = useCallback(
    (value: boolean) => {
      if (!value) {
        onChangeId('');
      }

      setVisible(value);
    },
    [onChangeId]
  );

  const history = useHistory();
  const setState = useRoleSetupStore((state) => state.setState);
  const state = useRoleSetupStore((state) => state.state);
  const handleSubmit = useCallback((data: IRoleSetup) => {
    setState({
      ...data,
      permissions: state.permissions,
      id: ''
    }); 
    history.push(ROUTES.ROLE_SETUP);
  } ,[history, setState, state]);

  const defaultValues = useMemo(() => {
    if(!data) {
      return null;
    }
    const payload: IRoleSetup = {
      ...data,
      name: `${data?.name || ''} (2)`,
      copyRoleId: id,
      isCopyRole: !!id,
    };
    return payload;
  }, [data, id]);

  return (
    <Modal testId='role-permissions-copy' visible={visible} onSetVisible={handleSetVisible} wrapperStyle={{ zIndex: 10000 }}>
      <RoleSetupForm
        key={data?.id}
        defaultValues={defaultValues}
        isLoading={isLoading}
        isModalMode
        onSubmit={handleSubmit}
        title={(
          <Text size="2xl" weight={700} margin={{ bottom: 'l' }} style={{ lineHeight: '32px' }}>
            Copy Permissions
          </Text>
        )}
        footer={(
          <Box  margin={{top: 'l'}} direction="row" justify="end">
            <AppButton testId='role-copy_cancel' width='160px' buttonType='secondary' onClick={() => handleSetVisible(false)}>
              Cancel
            </AppButton>
            <Box margin={{left: 's'}}>
              <AppButton testId='role-copy_apply'
                disabled={isLoading}
                width='160px' 
                type="submit"
                buttonType='primary'>
                Next (1/2)
              </AppButton>
            </Box>
          </Box>
        )}
      >
        <CopyPermissionsSection 
          isWithoutRemove
          isEditMode
        >
          <Box>
            <Text size="xxlarge" weight={400} margin={{bottom: 'xs'}}>
              Copy Permissions
            </Text>
            <Text>
              Create a new role by copying permissions from an existing one. Permissions are set up in the next configuration step.
            </Text>
          </Box>
        </CopyPermissionsSection>
      </RoleSetupForm>
     
    </Modal>
  );
};

export default RoleCopyModal;
